import ContentContainer from "../components/ContentContainer";
import Sidebar from "../components/Sidebar";

export default function Home() {
  return (
    <>
      <Sidebar />
      <ContentContainer />
    </>
  );
}
